import apiClient, { extractData } from "./client";

export async function getDepartments(params = {}) {
  const response = await apiClient.get("/departments", { params });
  return extractData(response);
}

export async function getDepartment(id) {
  const response = await apiClient.get(`/departments/${id}`);
  return extractData(response);
}

export async function createDepartment(data) {
  const response = await apiClient.post("/departments", data);
  return extractData(response);
}

export async function updateDepartment(id, data) {
  const response = await apiClient.patch(`/departments/${id}`, data);
  return extractData(response);
}

/** Soft-delete: deactivates the department (blocked if it has active employees). */
export async function deleteDepartment(id) {
  return updateDepartment(id, { isActive: false });
}
